
export const rawModules = [
    { key: "addresses", route: "/addresses/"},
    { key: "account_settings", folder: "account_settings", name: "AccountSetting", route: "/account-settings/" },
    { key: "ai_control", folder: "ai_control", name: "AIControl" },
    { key: "apps", folder: "apps", name: "App" },
    { key: "avatars", folder: "avatars", name: "Avatar", route: "/avatars/"},
    { key: "bank_accounts", folder: "bank_accounts", name: "BankAccount", route: "/bank-accounts/" },
    { key: "chat_designs", folder: "chat_designs", name: "ChatDesign", route: "/chat-designs/" },
    { key: "chat_history", folder: "chat_history", name: "ChatHistory", route: "/chat-history/" },
    { key: "chat_sessions", folder: "chat_sessions", name: "ChatSession", route: "/chat-sessions/" },
    { key: "chats", folder: "chats", name: "Chat", route: "/chats/" },
    { key: "communication_plans", folder: "communication_plans", name: "CommunicationPlan", route: "/communication-plans/" },
    { key: "companies", folder: "companies", name: "Company", route: "/company/" },
    { key: "contact_relationships", folder: "contact_relationships", name: "ContactRelationship", route: "/contact-relationships/" },
    { key: "contracts", folder: "contracts", name: "Contract", route: "/contracts/" },
    { key: "customers", folder: "customers", name: "Customer", route: "/contacts/" },
    { key: "dashboard", folder: "dashboard", name: "Dashboard" },
    { key: "documents", folder: "documents", name: "Document", route: "/documents/" },
    { key: "emails", folder: "email", name: "Email", route: "/email/", context: () => require("contexts/EmailContext").EmailProvider },
    { key: "events", folder: "events", name: "Event", route: "/events/", context: () => require("contexts/CampaignContext").CampaignProvider },
    { key: "event_participants", folder: "event_participants", name: "EventParticipant", route: "/event-participants/" },
    { key: "schedulers", folder: "schedulers", name: "Scheduler", route: "/schedulers/" },
    { key: "filter_trees", folder: "filter_trees", name: "FilterTree", route: "/filter-trees/" },
    { key: "import_data", folder: "import_data", name: "ImportData", route: "/import-data/" },
    { key: "integrations", folder: "integrations", name: "Integration", route: "/integrations/" },
    { key: "interactions", folder: "interactions", name: "Interaction", route: "/interactions/" },
    { key: "knowledge", folder: "knowledge", name: "Knowledge", route: "/knowledges/" },
    { key: "linkedin_actions", folder: "linkedin_actions", name: "LinkedInAction", route: "/linkedin-actions/" },
    { key: "message_templates", folder: "message_templates", name: "MessageTemplate", route: "/message-templates/" },
    { key: "metadata", folder: "metadata", name: "Metadata", route: "/metadata/" },
    { key: "notes", folder: "notes", name: "Note", route: "/notes/" },
    { key: "object", folder: "object", name: "Object", route: "/objects/" },
    { key: "orders", folder: "orders", name: "Order", route: "/orders/" },
    { key: "products", folder: "products", name: "Product", route: "/products/" },
    { key: "profile", folder: "profile", name: "Profile" },
    { key: "prompts", folder: "prompts", name: "Prompt", route: "/prompts/" },
    { key: "roles", folder: "roles", name: "Role", route: "/roles/" },
    { key: "settings", folder: "settings", name: "Settings" },
    { key: "signatures", folder: "signatures", name: "Signature", route: "/signatures/" },
    { key: "social_media_accounts", folder: "social_media_accounts", name: "SocialMediaAccount", route: "/social-media-accounts/" },
    { key: "tasks", folder: "tasks", name: "Task", route: "/tasks/" },
    { key: "tenants", folder: "tenants", name: "Tenant", route: "/tenants/" },
    { key: "term_corrections", folder: "term_corrections", name: "TermCorrection", route: "/term-corrections/" },
    { key: "todos", folder: "todos", name: "Todo", route: "/todos/" },
    { key: "todos_calendar", folder: "todos_calendar", name: "TodoCalendar" },
    { key: "todos_kanban", folder: "todos", name: "TodoKanbanFrame" },
    { key: "uploads", folder: "uploads", name: "Upload", route: "/uploads/" },
    { key: "users", folder: "users", name: "User", route: "/users/" },
];
  
export const OBJ = Object.fromEntries(rawModules.map(mod => [mod.key.toUpperCase(), mod.key]));
export const moduleRegistry = Object.fromEntries(rawModules.map(mod => [mod.key, mod]));

//Next steps:
// RouteObjects.js ==> Ad OBJ['key'] as menu item